import { render, staticRenderFns } from "./AcceptRejectedView.vue?vue&type=template&id=2b180ab3&"
import script from "./AcceptRejectedView.vue?vue&type=script&lang=js&"
export * from "./AcceptRejectedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports